import request from '@/utils/index'

export function getActivitiesList (datas) {
  return request({
    url: 'https://production.motorjourney.cn/v1/social/activity/ranking',
    method: 'get',
    headers: { 'x-api-key': datas }
  })
}

export function getActivitiesResult (datas) {
  return request({
    url: 'https://production.motorjourney.cn/v1/social/activity/end/ranking',
    method: 'get',
    headers: { 'x-api-key': datas }
  })
}

export function getActivitiesInfo (data) {
  return request({
    url: 'https://production.motorjourney.cn/admin/operation/searchInfo',
    method: 'POST',
    data
  })
}
